




































































































































































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { JobsStore } from '../models/jobs/jobs.vuex';
import { CompanyReferralIncentive } from '../models/referrals/companyReferralIncentive';
import { CompanyReferralIncentiveDetail } from '../models/referrals/companyReferralIncentiveDetail';
import { _ } from 'vue-underscore';
import { vxm } from '../store.vuex';

@Component({
  name: 'Referrals',
  components: {},
})
export default class Referrals extends Vue {
  @Prop() private JobID!: number;
  @Prop() private ReferralIncentive!: CompanyReferralIncentive;
  private jobStore = new JobsStore();
  private showingOnAssignment: boolean = true;
  $moment: any;
  isReferralIncentiveValid() {
    if (this.ReferralIncentive != null) {
      return this.ReferralIncentive.companyReferralIncentiveName === 'NA'
        ? false
        : true;
    }
    return false;
  }

  get isLoggedIn() {
    return vxm.users.isLoggedIn;
  }

  showOnAssignment() {
    this.showingOnAssignment = true;
  }

  showOffAssignment() {
    this.showingOnAssignment = false;
  }

  onAssignmentDetails() {
    const retDetails: CompanyReferralIncentiveDetail[] = [];

    // Validate referral incentive details.
    if (!this.ReferralIncentive.companyReferralIncentiveDetails)
      return retDetails;

    this.ReferralIncentive.companyReferralIncentiveDetails.forEach(
      (item, index) => {
        if (item.referringEmployeeStatus === '01') {
          retDetails.push(item);
        }
      },
    );
    return retDetails;
  }

  offAssignmentDetails() {
    const retDetails: CompanyReferralIncentiveDetail[] = [];

    // Validate referral incentive details.
    if (!this.ReferralIncentive.companyReferralIncentiveDetails)
      return retDetails;

    this.ReferralIncentive.companyReferralIncentiveDetails.forEach(
      (item, index) => {
        if (item.referringEmployeeStatus !== '01') {
          retDetails.push(item);
        }
      },
    );
    return retDetails;
  }

  numberWithCommas(pay: string) {
    pay += '';
    var x = pay.split('.');
    var x1 = x[0];
    var x2 = x.length > 1 ? '.' + x[1] : '';
    var rgx = /(\d+)(\d{3})/;
    while (rgx.test(x1)) {
      x1 = x1.replace(rgx, '$1' + ',' + '$2');
    }
    return x1 + x2;
  }

  getOnAssignedList(companyReferralIncentiveDetails: Array<any>) {
    const retDetails: CompanyReferralIncentiveDetail[] = [];

    // Validate referral incentive details.
    if (!this.ReferralIncentive.companyReferralIncentiveDetails)
      return retDetails;

    companyReferralIncentiveDetails.forEach((item, index) => {
      if (item.referringEmployeeStatus !== '01') {
        retDetails.push(item);
      }
    });
    return retDetails;
  }
  removeBrTg(tag: any): string {
    const link = tag.replace('<br>', ' ');
    return link;
  }
  renderDate(xDate: any): string {
    if (vxm.jobs.getCompanyDateFormat) {
      return this.$moment(xDate).format(
        vxm.jobs.getCompanyDateFormat.toUpperCase(),
      );
    }
    return this.$moment(xDate).format('DD-MMM-YYYY');
  }

  renderEndDate(xDate: any): string {
    var endDate = new Date(xDate);
    if (vxm.jobs.getCompanyDateFormat) {
      return this.$moment
        .utc(endDate, 'MM-DD-YYYY')
        .format(vxm.jobs.getCompanyDateFormat.toUpperCase());
    }
    return this.$moment.utc(endDate, 'MM-DD-YYYY').format('DD-MMM-YYYY');
  }
  renderDOW(dow: number): string {
    let day = '';
    switch (dow) {
      case 0:
        day = 'Sunday';
        break;
      case 1:
        day = 'Monday';
        break;
      case 2:
        day = 'Tuesday';
        break;
      case 3:
        day = 'Wednesday';
        break;
      case 4:
        day = 'Thursday';
        break;
      case 5:
        day = 'Friday';
        break;
      case 6:
        day = 'Saturday';
    }
    return day;
  }
}
